import React, { Component } from 'react';
import { connect } from 'react-redux';
import DocumentTitle from 'react-document-title';

export default (Child, props) => {
    return (
        <DocumentTitle title={"Hansa Bot - " + props.title}>
            <Child {...props} />
        </DocumentTitle>
    );
};



// WEBPACK FOOTER //
// ./src/hocs/setTitlePage.js